module.exports = __webpack_public_path__ + "f80eee7475909a8701e506d8619348d3.glb";